import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row} from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const ServiceAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  const typeOptions = [
    { key: "INTERNAL_SRV", value: "INTERNAL_SRV" },
    { key: "EXTERNAL_SRV", value: "EXTERNAL_SRV" }
  ];

  // Initialize with actual JSON obj.  If not, will get error.
  const [serviceAttrs,     setServiceAttrs]     = useState({});
  const [currServiceAttrs, setCurrServiceAttrs] = useState({});

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg,        setErrMsg]        = useState('');
  const [errMsg_Status, setErrMsg_Status] = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setServiceAttrs(props.objDetails);
      setCurrServiceAttrs(props.objDetails);
    }
  }, [props]);


  const refreshServiceAttrs = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("services/" + serviceAttrs.id);

        resolve(res.data);

        if (res.status === 200) {
          setServiceAttrs(res.data[0]);
          setCurrServiceAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setServiceAttrs({ ...serviceAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setServiceAttrs({ ...serviceAttrs, type: key });
  }

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setServiceAttrs(currServiceAttrs);

    setEditMode(false);
    setErrMsg('');
  }


  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate code and name
    if (!serviceAttrs.code || serviceAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (!serviceAttrs.name || serviceAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (serviceAttrs.code.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
      return;
    } else if (serviceAttrs.name.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 30);
      return;
    } else if (!serviceAttrs.description || serviceAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (!serviceAttrs.type || serviceAttrs.type.length === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));
      return;
    } else if (serviceAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_description") + 200);
      return;
    } else if (serviceAttrs.type.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_type") + 30);
      return;
    } else if (serviceAttrs.pingEndpoint && serviceAttrs.pingEndpoint.length > 500) {
      setErrMsg(t("I18N_ERR_Max_len_ping_endpt") + 500);
      return;
    } else if (   (serviceAttrs.pollInterval != null)
               && (serviceAttrs.pollInterval.toString().trim().length !== 0)
               && (!Number.isInteger(Number(serviceAttrs.pollInterval.toString().trim())))) {
      setErrMsg(t("I18N_Poll_interval") + t("I18N_ERR_must_be_int"));
      return;
    }

    // Persistify update
    const reqBody = serviceAttrs;

    if ((reqBody.pingEndpoint != null) && (reqBody.pingEndpoint.trim().length === 0)) {
      reqBody.pingEndpoint = null;
    }

    if ((reqBody.pollInterval != null) && (reqBody.pollInterval.toString().trim().length === 0)) {
      reqBody.pollInterval = null;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("services/" + serviceAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg('');

          refreshServiceAttrs();
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleToggleMaintenance = (setting) => {

    const reqBody = { status: (setting === 'ON') ? 'MAINTENANCE' : 'MAINT_OFF' }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.patch("services/" + serviceAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg_Status('');
          refreshServiceAttrs();
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Status(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Service_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Service_Info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Code")}: *</Col>
                  <Col md={3}>{t("I18N_Name")}: *</Col>
                  <Col md={3}>{t("I18N_Description")}: *</Col>
                  <Col md={3}>{t("I18N_Type")}: </Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code" value={serviceAttrs.code}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={serviceAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={serviceAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!serviceAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (typeOptions.find( ({ key }) => key === serviceAttrs.type )).value)}
                      onSelect={onTypeSelect}>
                      {typeOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col md={3}>{t("I18N_Ping_endpoint")}:</Col>
                  <Col md={3}>{t("I18N_Poll_interval") + " (" + t("I18N_minutes") + ")"}:</Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="pingEndpoint" value={serviceAttrs.pingEndpoint}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="pollInterval" value={serviceAttrs.pollInterval}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Code")}:</Col>
                <Col md={3}>{t("I18N_Name")}:</Col>
                <Col md={3}>{t("I18N_Description")}:</Col>
                <Col md={3}>{t("I18N_Type")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{serviceAttrs.code}</Col>
                <Col md={3}>{serviceAttrs.name}</Col>
                <Col md={3}>{serviceAttrs.description}</Col>
                <Col md={3}>{t("I18N_" + serviceAttrs.type)}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col md={3}>{t("I18N_Ping_endpoint")}:</Col>
                <Col md={3}>{t("I18N_Poll_interval") + " (" + t("I18N_minutes") + ")"}:</Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{serviceAttrs.pingEndpoint}</Col>
                <Col md={3}>{serviceAttrs.pollInterval}</Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{serviceAttrs.creatorUsername}</Col>
                <Col>{formatDate(serviceAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{serviceAttrs.updaterUsername}</Col>
                <Col>{formatDate(serviceAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Service_Status")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            <Container>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col md={3}>{t("I18N_Status")}:</Col>
                <Col md={3}>{t("I18N_Status_time")}:</Col>
                <Col md={3}>{t("I18N_Error")}:</Col>
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{serviceAttrs.status ? t("I18N_" + serviceAttrs.status) : t("I18N_NA")}</Col>
                <Col md={3}>{formatDate(serviceAttrs.statusTime)}</Col>
                <Col md={3}>{serviceAttrs.error}</Col>
                <Col md={3}></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col md={3}>{t("I18N_Begin_active_time")}:</Col>
                <Col md={3}>{t("I18N_End_active_time")}:</Col>
{/*
                <Col md={3}>{t("I18N_Last_failed_time")}:</Col>
                <Col md={3}>{t("I18N_Last_sync_time")}:</Col>
*/}
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{formatDate(serviceAttrs.beginActiveTime)}</Col>
                <Col md={3}>{formatDate(serviceAttrs.endActiveTime)}</Col>
{/*
                <Col md={3}>{formatDate(serviceAttrs.lastFailedTime)}</Col>
                <Col md={3}>{formatDate(serviceAttrs.lastSyncTime)}</Col>
*/}
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  { !serviceAttrs.status || (serviceAttrs.status && (serviceAttrs.status !== 'MAINTENANCE')) ?
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={() => handleToggleMaintenance('ON')}>
                      {t("I18N_Turn_on_maint")}
                    </Button>
                  :
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={() => handleToggleMaintenance('OFF')}>
                      {t("I18N_Turn_off_maint")}
                    </Button>
                  }
                  <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_Status}
                  </span>
                </div>
              </Row>

            </Container>
          </div>

        <hr className="solid" style={{ marginTop: '20px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default ServiceAdminDetailsView;
